import HubFilter from "components/shared-components/RemoteTable/HubFilter/HubFilter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { ORDER_TYPE_RECEIVE, ORDER_TYPE_RETURN } from "constants/order";
import { useCountOrderByRunner, useListRunnerHub } from "hooks";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Col, Row } from "reactstrap";
import RunnerFilterDropDown from "./RunnerFilterDropDown";
import OrderTypeDropDown from "./OrderTypeDropDown";
import DateFilter from "./DateFilter";

const HubStatistic = () => {
  const { t } = useTranslation(["orderStatistic"]);
  const initialCountOrderByRunnerParams = {
    run: false,
    columnFilterKeep: {
      order_type: "1,2",
      from_time: `${moment().format("YYYY-MM-DD")} 00:00:00`,
      to_time: `${moment().format("YYYY-MM-DD")} 23:59:00`,
      runner_id: "1",
      search_mode: "action-date",
    },
    columnFilter: {},
  };
  const [countOrderByRunnerParams, setCountOrderByRunnerParams] = useState(
    initialCountOrderByRunnerParams
  );
  const [listRunnerHubParams, setListRunnerHubParams] = useState({
    columnFilter: {},
  });
  const [actionDateFilter, setActionDateFilter] = useState({
    startDate: moment(),
    endDate: moment(),
    active: true,
  });
  const [solutionDateFilter, setSolutionDateFilter] = useState({
    startDate: undefined,
    endDate: undefined,
    active: false,
  });

  const [runnerFilter, setRunnerFilter] = useState(undefined);
  const [orderTypeFilter, setOrderTypeFilter] = useState({
    label: "Tất cả",
    value: "all",
  });
  const [center, setCenter] = useState(undefined);
  const {
    data: dataCountOrderByRunner,
    refetch: fetchCountOrderByRunner,
    isLoading: isLoadingCountOrderByRunner,
  } = useCountOrderByRunner({
    key: countOrderByRunnerParams.order_type,
    enabled: false,
    params: countOrderByRunnerParams,
  });

  const { data: hubRunners, refetch: fetchRunnerHubList } = useListRunnerHub(
    listRunnerHubParams.columnFilter
  );
  useEffect(() => {
    if (listRunnerHubParams.columnFilter.hub_id) {
      fetchRunnerHubList();
    }
  }, [listRunnerHubParams]);

  useEffect(() => {
    if (hubRunners && hubRunners.length) {
      setRunnerFilter({
        label: "Tất cả",
        value: "all",
      });
      const runnerIds = hubRunners.flatMap(item => item.id).join(",");
      setCountOrderByRunnerParams(prev => ({
        ...prev,
        columnFilter: {
          ...prev.columnFilter,
          runner_id: runnerIds,
        },
        run: true,
      }));
    }
  }, [hubRunners]);

  useEffect(() => {
    if (countOrderByRunnerParams.run) {
      fetchCountOrderByRunner();
    }
  }, [countOrderByRunnerParams]);

  const columnTable = [
    {
      dataField: "hub_name",
      text: t("table.hub_name"),
    },
    {
      dataField: "runner_name",
      text: t("table.runner_name"),
    },
    {
      dataField: "active_order_amount",
      text: t("table.active_order_amount"),
    },
    {
      dataField: "completed_order_amount",
      text: t("table.completed_order_amount_runner"),
    },
  ];

  const handleOrderTypeFilter = type => {
    setOrderTypeFilter(type);
    setCountOrderByRunnerParams(prev => ({
      ...prev,
      columnFilter: {
        ...prev.columnFilter,
        order_type: type.value,
      },
    }));
  };

  const handleDateRangeFilter = ({ startDate, endDate }, search_mode) => {
    if (search_mode === "action-date") {
      setActionDateFilter({
        startDate,
        endDate,
        active: true,
      });

      setSolutionDateFilter(prev => ({
        startDate: undefined,
        endDate: undefined,
        active: false,
      }));
    } else {
      setSolutionDateFilter({
        startDate,
        endDate,
        active: true,
      });

      setActionDateFilter(prev => ({
        startDate: undefined,
        endDate: undefined,
        active: false,
      }));
    }

    if (startDate && endDate) {
      const filterDate = {
        from_time: startDate
          ? `${startDate.format("YYYY-MM-DD")} 00:00:00`
          : null,
        to_time: endDate ? `${endDate.format("YYYY-MM-DD")} 23:59:00` : null,
      };
      setCountOrderByRunnerParams(prev => ({
        ...prev,
        columnFilter: {
          ...prev.columnFilter,
          ...filterDate,
          search_mode,
        },
      }));
    }
  };

  const handleClickChangeDate = search_mode => {
    if (search_mode === "action-date") {
      handleDateRangeFilter(
        {
          startDate: actionDateFilter.startDate,
          endDate: actionDateFilter.endDate,
        },
        search_mode
      );
    } else {
      handleDateRangeFilter(
        {
          startDate: solutionDateFilter.startDate,
          endDate: solutionDateFilter.endDate,
        },
        search_mode
      );
    }
  };

  const runnerListOptions = useMemo(() => {
    if (hubRunners && hubRunners.length) {
      return [
        {
          label: "Tất cả",
          value: "all",
        },
        ...hubRunners.flatMap(item => ({
          label: item.display_name,
          value: item.id,
        })),
      ];
    }
    return [];
  }, [hubRunners]);

  const handleChangeRunnerFilter = runner => {
    setRunnerFilter(runner);
    if (runner.value === "all") {
      const runnerIds = hubRunners.flatMap(item => item.id).join(",");
      setCountOrderByRunnerParams(prev => ({
        ...prev,
        columnFilter: {
          ...prev.columnFilter,
          runner_id: runnerIds,
        },
      }));
    } else {
      setCountOrderByRunnerParams(prev => ({
        ...prev,
        columnFilter: {
          ...prev.columnFilter,
          runner_id: runner.value,
        },
      }));
    }
  };

  return (
    <>
      <div className="filter-runner d-flex flex-row justify-content-start align-items-center">
        <DateFilter
          actionDateFilter={actionDateFilter}
          handleDateRangeFilter={handleDateRangeFilter}
          handleClickChangeDate={handleClickChangeDate}
          solutionDateFilter={solutionDateFilter}
        />
        <div>
          <OrderTypeDropDown
            label={"Loại đơn hàng"}
            stateValue={orderTypeFilter}
            options={[
              {
                label: "Tất cả",
                value: "1,2",
              },
              ORDER_TYPE_RECEIVE,
              ORDER_TYPE_RETURN,
            ]}
            onChange={handleOrderTypeFilter}
          />
        </div>
        <HubFilter
          isForOrder
          mainFilterParams={listRunnerHubParams}
          setMainFilterParams={setListRunnerHubParams}
          isNotFilterChildHub={false}
          isHaveAllOption={false}
          isFilterAllDefault={false}
          isHidden={true}
          handleSelectHub={(ids, _, hub) => {
            if (ids && ids.length) {
              setCenter({
                id: ids[0],
                name: hub.name,
              });
            }
          }}
        />
        <RunnerFilterDropDown
          label={"Runner"}
          stateValue={runnerFilter}
          options={runnerListOptions}
          onChange={handleChangeRunnerFilter}
          isHidden={true}
        />
      </div>
      {(actionDateFilter.startDate && actionDateFilter.endDate) ||
      (solutionDateFilter.startDate && solutionDateFilter.endDate) ? (
        <Row className="justify-content-around">
          <Col xs={12} md={6} className="px-4">
            {/* <h5>Thống kê đơn runner của {center?.name}</h5> */}
            <RemoteDataTable
              keyField="runner_id"
              data={
                dataCountOrderByRunner?.filter(
                  item => item.hub_id === center?.id
                ) || []
              }
              columns={columnTable}
              isShowRowIndex={false}
              isShowPagination={false}
              isShowSearchAll={false}
              searchSticky={true}
              classNameTable="order-statistic-table"
              loading={isLoadingCountOrderByRunner}
            />
          </Col>
          <Col xs={12} md={6} className="px-4">
            {/* <h5>Thống kê đơn runner của các Hub</h5> */}
            <RemoteDataTable
              keyField="runner_id"
              data={
                dataCountOrderByRunner?.filter(
                  item => item.hub_id !== center?.id
                ) || []
              }
              columns={columnTable}
              isShowRowIndex={false}
              isShowPagination={false}
              isShowSearchAll={false}
              searchSticky={true}
              classNameTable="order-statistic-table"
              loading={isLoadingCountOrderByRunner}
            />
          </Col>
        </Row>
      ) : (
        <Alert color="danger" className="mt-4">
          {t("message.alert_date_null")}
        </Alert>
      )}
    </>
  );
};

export default HubStatistic;
